export default __webpack_public_path__ + "static/media/welt-plus.3fc40ad9.png";